var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./loading.vue"),
  /* template */
  require("!!../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-29e0f5c0\"}!../../../../../vue-loader/lib/selector?type=template&index=0!./loading.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/loading/src/loading.vue
// module id = 658
// module chunks = 228